import React, { useContext } from 'react';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import EditorDeviationLink from '../../_partials/DeviationLink';
import { getSizeForFreeform } from '../../helpers';
import TierPromotionCardSemiDumb from '../../../../DeviationViews/TierPromotionCardSemiDumb';
import s from './Tier.scss';
const TierMonoReactView = ({ config, settings, deviation })=>{
    const isMobile = useContext(MobileContext);
    let size;
    if (isMobile) {
        size = {
            width: 300,
            height: 160
        };
    } else {
        size = {
            width: 544,
            height: 295
        };
        // Handle resizing
        size = getSizeForFreeform(size, config.width);
        // This is the size you'd see in left/right aligned setting
        // or small editors such as comments
        if (config.size === 'small' || (settings === null || settings === void 0 ? void 0 : settings.showMediaAlwaysSmall)) {
            size = {
                width: 350,
                height: 190
            };
        }
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], s['normal']),
        style: {
            width: size.width
        }
    }, /*#__PURE__*/ React.createElement(EditorDeviationLink, {
        link: config.link,
        deviation: deviation,
        className: s['tier-link']
    }, /*#__PURE__*/ React.createElement(TierPromotionCardSemiDumb, {
        width: size.width,
        height: size.height,
        deviation: deviation,
        ctaButton: "subscribe"
    })));
};
TierMonoReactView.displayName = 'TierMonoReactView';
export default TierMonoReactView;

//# sourceMappingURL=Tier.js.map